import React, { Fragment } from "react";
import Select from "react-select";

class Fuzzy extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedOption: ""
        };

        this.countOptions = this.countOptions.bind(this);
    }

    // Give us window level access to results
    componentWillMount() {
        window.results = document.querySelectorAll(".fuzzy__input");
    }

    // Push current results to window results for GTM access
    countOptions() {
        const results = document.querySelectorAll(".fuzzy__input");
        window.results = results;
    }

    // Handle Jump and Push
    handleChange = selectedOption => {
        this.setState({ selectedOption }, function() {
            this.props.history.push(
                `${this.state.selectedOption.path}${
                    this.state.selectedOption.value
                }/`
            );
        });

        // GTM Event
        window.dataLayer.push({
            event: "search",
            searchPhrase: selectedOption.label,
            searchResults: window.results.length
        });
    };

    render() {
        const { selectedOption } = this.state;
        const value = selectedOption && selectedOption.value;

        return (
            <Fragment>
                    <Select
                        {...this.props}
                        name="fuzzy-search"
                        value={value}
                        onChange={this.handleChange}
                        onInputChange={this.countOptions}
                        className="fuzzy-search"
                        options={this.props.links}
                        placeholder="Industry or Product"
                        optionClassName="fuzzy__input"
                    />
            </Fragment>
        );
    }
}

export default Fuzzy;



// WEBPACK FOOTER //
// ./src/components/Fuzzy.js